/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCUpIcon32Regular = forwardRef('ArrowCUpIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M4.793 21.207a1 1 0 0 1 0-1.414l8.379-8.379a4 4 0 0 1 5.656 0l8.38 8.379a1 1 0 0 1-1.415 1.414l-8.379-8.379a2 2 0 0 0-2.828 0l-8.379 8.38a1 1 0 0 1-1.414 0Z" })));
});
